import wretch from 'wretch';
import { tracingPropagate } from './middlewares/trace-propagation';

export const baseTransport = wretch();

export const transport = wretch()
  .middlewares([tracingPropagate()])
  .options({ credentials: 'same-origin' })
  .accept('application/json')
  .content('application/json');

export type ITransport = typeof transport;
